import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import styles from "./setup-class-routine.js.module.css";
import ClassesStatisticsOverview from "./components/statistics-overview/statistics-overview";
import ClassesViewTabs from "./components/classes-view-tabs/classes-view-tabs";
import { fetchInstitutionSummary } from "../../../services/class_routine";

const SetupClassRoutine = () => {
  const [loading, setLoading] = useState(false);
  const [institutionOverview, setInstitutionOverview] = useState(null);
  const [classList, setClassList] = useState([]);

  useEffect(() => {
    getInstitutionSummary();
  }, []);

  const getInstitutionSummary = async () => {
    try {
      setLoading(true);
      const response = await fetchInstitutionSummary();
      if (response?.status) {
        setInstitutionOverview(response?.data?.summary);
        setClassList(response?.data?.levels);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div className={styles.teachers}>
      <Typography className={styles.title}>Overview</Typography>
      <ClassesStatisticsOverview institutionOverview={institutionOverview} />
      <ClassesViewTabs 
        loading={loading}
        classList={classList} 
        getInstitutionSummary={getInstitutionSummary}
      />
    </div>
  );
};

export default SetupClassRoutine;
